import { useEffect, useState, FC } from 'react'
import { TreeSelect, TreeSelectProps} from 'antd'
import { getProductCategories } from '@services/productService'
const { TreeNode } = TreeSelect

function treeSelect(children, parentName?: string | null, leafOnly?: boolean, disabledNode?: Array<number>) {
  return children && children.length > 0 ? (
    children.map((item) => {
      return (
        <TreeNode
          disabled={(leafOnly && item.children?.length) || disabledNode?.includes(item.category.id.length)}
          value={item.category.id}
          title={`${item.category.id}-${parentName ? parentName + '-' : ''}${item.category.displayTerm
              }(${item.category.term})`}
          key={item.category.id}
        >
          {item.children &&
            item.children.length > 0 &&
            treeSelect(
              item.children,
              `${parentName ? parentName + '-' : ''}${item.category.displayTerm}`,
              leafOnly,
              disabledNode
            )}
        </TreeNode>
      )
    })
  ) : null
}

interface CategorySelectProps extends TreeSelectProps{
  onCategoriesLoad?: (data: any) => void
  leafOnly?: boolean
  disabledNode?: Array<number>
}

const CategorySelect: FC<CategorySelectProps> = props => {
  const {
    className,
    placeholder,
    onCategoriesLoad,
    disabled,
    value,
    onChange,
    multiple,
    leafOnly = false,
    disabledNode,
    ...properties
  } = props
  const [categories, setCategories] = useState<any>({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    getProductCategories()
      .then(res => {
        // console.log(res)
        setCategories(res.data)
        onCategoriesLoad && onCategoriesLoad(res.data)
        setLoading(false)
      })
      .catch(error => {
        console.error(error)
        setLoading(false)
      })
  }, [])

  return (
    <TreeSelect
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={className}
      dropdownStyle={{ maxHeight: 400 }}
      style={{ minWidth: 200, maxWidth: 400 }}
      placeholder={ placeholder || 'Please select categories' }
      showSearch
      allowClear
      loading={loading}
      treeNodeFilterProp="title"
      multiple={multiple}
      dropdownMatchSelectWidth={false}
      {...properties}
    >
      {categories && categories.category && treeSelect(categories.children, null, leafOnly, disabledNode)}
    </TreeSelect>
  )
}

export default CategorySelect
